import { FC, ReactElement } from 'react'

import FilterBlock from '../../../../components/Filters/subcomponents/FilterBlock/FilterBlock'
import { Checkbox } from '../../../components'
import trans from '../../../helpers/trans'

import './EmployeesFilterContainer.scss'

interface EmployeesFilterContainerProps {
    showAllShiftsWithAbsences: boolean;
    showAllShiftsWithOpenLeaveOfAbsences: boolean;
    showEmploymentTypes: boolean;
    onShowAllShiftsWithAbsencesChange: (show: boolean) => void;
    onShowAllShiftsWithOpenLeaveOfAbsencesChange: (show: boolean) => void;
    onShowEmploymentTypesChange: (show: boolean) => void;
    className?: string;
}

const EmployeesFilterContainer: FC<EmployeesFilterContainerProps> = ({
    showAllShiftsWithAbsences,
    showAllShiftsWithOpenLeaveOfAbsences,
    showEmploymentTypes,
    onShowAllShiftsWithAbsencesChange,
    onShowAllShiftsWithOpenLeaveOfAbsencesChange,
    onShowEmploymentTypesChange,
    className = '',
}): ReactElement => (
    <FilterBlock
        title={trans('common.employees')}
        className={`employees-filter-container ${className}`}
    >
        <Checkbox
            label={trans('containers.filters.employees.showAllShiftsWithLeaveOfAbsences')}
            checked={showAllShiftsWithOpenLeaveOfAbsences}
            onChange={onShowAllShiftsWithOpenLeaveOfAbsencesChange}
            checkClassName="employees-filter-container__check-box"
            labelClassName="employees-filter-container__check-label"
            className="employees-filter-container__check"
        />
        <Checkbox
            label={trans('containers.filters.employees.showAllShiftsWithAbsences')}
            checked={showAllShiftsWithAbsences}
            onChange={onShowAllShiftsWithAbsencesChange}
            labelClassName="employees-filter-container__check-label"
            checkClassName="employees-filter-container__check-box"
            className="employees-filter-container__check"
        />
        <Checkbox
            label={trans('containers.filters.employees.showEmploymentTypes')}
            checked={showEmploymentTypes}
            onChange={onShowEmploymentTypesChange}
            labelClassName="employees-filter-container__check-label"
            checkClassName="employees-filter-container__check-box"
            className="employees-filter-container__check"
        />
    </FilterBlock>
)

export default EmployeesFilterContainer
